import {
  IconBulb,
  IconFileBarcode,
  IconMessage,
  IconSquarePlus,
} from '@tabler/icons-react'
import { Tooltip } from 'antd'
import classNames from 'classnames'
import React, { ReactNode } from 'react'

import { formatPrice } from '@/utils/formatter'

import s from './creator-earning-summary.module.css'

export interface CreatorEarningsSummaryProps {
  totalEarnings?: number
  subscriptionsEarning?: number
  tipsEarning?: number
  postsEarning?: number
  messageCount?: number
  postCount?: number
  showEarningCounts?: boolean
}

interface EarningItemProps {
  title: string
  earnings: number
  icon: ReactNode
  iconClassName?: string,
}

const EarningItem = ({
  title,
  earnings,
  icon,
  iconClassName,
}: EarningItemProps) => (
  <div className={s.EarningItem}>
    <div className={s.EarningTitle}>
      <div className={classNames(s.EarningIcon, iconClassName)}>
        {icon}
      </div>
      <span className={s.EarningDescription}>
        <Tooltip title={title}>
          {title}
        </Tooltip>
      </span>
    </div>
    <div className={s.EarningAmount}>
      <Tooltip title={formatPrice({ currency: '' })(earnings)}>
        {formatPrice()(earnings)}
      </Tooltip>
    </div>
  </div>
)

export default function CreatorEarningSummary({
  totalEarnings = 0,
  subscriptionsEarning = 0,
  tipsEarning = 0,
  postsEarning = 0,
  messageCount = 0,
  postCount = 0,
  showEarningCounts = false,
}: CreatorEarningsSummaryProps) {
  return (
    <div className={s.EarningSummary}>
      <EarningItem
        title='Total Earnings'
        earnings={totalEarnings}
        icon={<IconSquarePlus size={20} />}
        iconClassName={s.TotalEarnings}
      />
      <EarningItem
        title='Subscriptions'
        earnings={subscriptionsEarning}
        icon={<IconBulb size={20} />}
        iconClassName={s.Subscriptions}
      />
      <EarningItem
        title='Tips'
        earnings={tipsEarning}
        icon={<IconMessage size={20} />}
        iconClassName={s.Tips}
      />
      <EarningItem
        title='Posts'
        earnings={postsEarning}
        icon={<IconFileBarcode size={20} />}
        iconClassName={s.Posts}
      />
      {showEarningCounts && (
        <div className={s.EarningCounts}>
          <div className={s.EarningCountsItem}>
            <span>Messages</span>
            <span>{messageCount}</span>
          </div>
          <div className={s.EarningCountsItem}>
            <span>Posts</span>
            <span>{postCount}</span>
          </div>
        </div>
      )}
    </div>
  )
}
